import gql from "graphql-tag";

export const EDIT_REPORT_SHEET_INFO_MUTATION = gql`
  mutation EditReportSheetInfo($reportId: ID!, $sheetId: ID!, $properties: SheetInfo!) {
    editReportSheetInfo(reportId: $reportId, sheetId: $sheetId, properties: $properties)
  }
`;
